export enum InternalParams {
  SPEED_MARGIN = 0.95,
}
